import { useContext } from 'react';
import * as React from 'react';
import merge from 'lodash.merge';
import { Mode } from './types';
import { extendI18n, changeLocale, captureErrorSentry, removeTrailingSlash } from './utils';
import { setApiUrl } from './graphql-client';
import { StepsEnum } from './types';
import { LocationGroupType, OauthServiceType, OrderAdditionalServiceGdsServiceServiceType, ExareStatus } from '@websky/graphql';
import { Sorting } from './Results/enums';
import ConfigSchema from './configSchema/index';
export const defaultPassengersConfig = [
    {
        code: 'ADT',
        isAdult: true,
        defaultCount: 1
    },
    {
        code: 'CLD',
        isAdult: false,
        maxCountWithoutAdult: 0
    },
    {
        code: 'INF',
        isAdult: false
    },
    {
        code: 'INS',
        isAdult: false
    }
];
export const defaultConfig = {
    FlightStatus: {
        engineURL: '',
        appStoreURL: 'https://apps.apple.com/id/app/websky-app/id1567545689',
        playMarketURL: 'https://play.google.com/store/apps/details?id=aero.websky.demo',
        accessToken: 'pk.eyJ1Ijoic2NhdC1haXJsaW5lcyIsImEiOiJjbHFieWNteHMwOTU0Mml0a3Y4bTFsYWxmIn0.5G_TN53qWDMx0aY3IeDVbw',
        starlineAccessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIiwiZG9tYWluIjoiIn0.eyJpc3MiOiJodHRwczovL21hcHMuc3RhcmxpbmUucnUiLCJpYXQiOjE3MzkxODc5ODQuMDkxODE3LCJ1aWQiOjQ0fQ.',
        starlineStyleId: '5b54b75f-153f-44f7-bc2a-826acf291981',
        stylesEn: 'mapbox://styles/evgenylitvinenkomlsd/clq2mj6h301tk01pa3xaqg95c',
        stylesRu: 'mapbox://styles/evgenylitvinenkomlsd/clkv3s6c8001z01pd51do54s1'
    },
    SearchForm: {
        redwingsForeignCardPaymentCheckbox: false,
        maxComplexRouteSegments: 2,
        enableComplexRoute: true,
        mobileFormType: 'alternative',
        engineURL: '',
        payByMiles: false,
        showFfpBonusInfoInFares: false,
        requestCoordintates: {
            desktop: true,
            mobile: true
        },
        maxPassengersCount: 9,
        passengersConfig: defaultPassengersConfig,
        offerHotels: false,
        offerHotelsDefaultState: true,
        offerHotelsLink: 'https://ostrovok.ru/hotels',
        locationGroups: {
            showAdditionalGroups: true,
            additionalGroupTypes: [
                LocationGroupType.AdditionalCities,
                LocationGroupType.Nearest,
                LocationGroupType.Popular
            ]
        },
        separatedDatepicker: false,
        additionalLinks: [],
        useFlightsSchedule: false,
        alwaysOpen: false
    },
    Engine: {
        searchFormURL: '',
        defaultSteps: {
            flights: {
                label: 'Flights'
            },
            seats: {
                label: 'Seats'
            },
            passengers: {
                label: 'Passengers'
            },
            order: {
                label: 'Order'
            },
            payment: {
                label: 'Payment'
            }
        },
        checkInURL: '',
        accountURL: '',
        mealWarning: '',
        promoLoaders: [],
        simpleLoaders: [],
        checkInEnabled: false,
        checkFfpStatus: false,
        showRefundRedirectButton: false,
        showTicketRefundOptionModal: false,
        calendarDaysCount: 7,
        showAvailableFaresOnly: false,
        sortResultPreferCurrentAirline: false,
        resultsFareSelectorInModal: true,
        ignoreBlockedPaymentToReturnOrder: true,
        googleOneTapSignInClientId: null,
        exareShowPassengersStep: true,
        resultsDefaultSorting: Sorting.Price,
        nas: {
            suggestServicesTypes: [
                OrderAdditionalServiceGdsServiceServiceType.Baggage,
                OrderAdditionalServiceGdsServiceServiceType.Seat,
                OrderAdditionalServiceGdsServiceServiceType.Meal,
                OrderAdditionalServiceGdsServiceServiceType.Misc
            ],
            suggestedServicesOrder: {
                insurance: 0,
                insuranceGroups: 0,
                [OrderAdditionalServiceGdsServiceServiceType.Meal]: 1,
                [OrderAdditionalServiceGdsServiceServiceType.Baggage]: 2,
                [OrderAdditionalServiceGdsServiceServiceType.Seat]: 3,
                [OrderAdditionalServiceGdsServiceServiceType.Misc]: 4
            }
        },
        RTMinPricesForOWFlights: false,
        useActualizedOrderFlightPrices: true,
        refund: {
            successModal: {
                create: {
                    [ExareStatus.InProcess]: true,
                    [ExareStatus.NeedConfirm]: true,
                    [ExareStatus.AwaitingPayment]: true,
                    [ExareStatus.Finished]: true,
                    [ExareStatus.Rejected]: true,
                    [ExareStatus.Refused]: true,
                    [ExareStatus.TimelimitExpired]: true
                },
                request: {
                    [ExareStatus.InProcess]: true,
                    [ExareStatus.NeedConfirm]: true,
                    [ExareStatus.AwaitingPayment]: true,
                    [ExareStatus.Finished]: true,
                    [ExareStatus.Rejected]: true,
                    [ExareStatus.Refused]: true,
                    [ExareStatus.TimelimitExpired]: true
                }
            }
        }
    },
    Account: {
        engineURL: '',
        showUserPhoneInput: true,
        showCommunications: false,
        showSubscribeCheckbox: false,
        initialStayLoggedIn: false
    },
    Checkin: {
        CheckinConditions: ['OpenCloseCheckinCondition', 'BaggageCondition', 'PassengersCondition'],
        showConsents: false,
        checkinRestrictionsEnabled: false
    },
    global: {
        savePreselectedWithoutUserAction: {
            types: []
        },
        additionalResources: {
            scripts: ['https://secure.sirena-travel.ru/media/js/pg-additional-1.0.min.js'],
            extraScripts: [],
            svgs: ['https://cdn.websky.aero/content/ZZ/images/icons.svg'],
            extraSvgs: []
        },
        socialAuthMethods: [
            { service: OauthServiceType.Vkontakte, isAvailable: false },
            { service: OauthServiceType.Google, isAvailable: false },
            { service: OauthServiceType.Facebook, isAvailable: false },
            { service: OauthServiceType.TinkoffID, isAvailable: false },
            { service: OauthServiceType.Telegram, isAvailable: false },
            { service: OauthServiceType.SberID, isAvailable: false },
            { service: OauthServiceType.AlfaID, isAvailable: false }
        ],
        authMethods: {
            phone: false,
            ffp: true,
            email: true,
            blockedRegistrationEmailDomains: ['gmail.com', 'icloud.com']
        },
        showIsActualizationResultOk: true,
        allowPromoCodes: false,
        i18n: {},
        findOrderURL: '',
        seatMap: {
            splitByCabin: false,
            showRecommendedSeats: false,
            showFilters: false,
            showPriceInSeat: false
        },
        insurance: {
            upsaleStrategy: ['checkout-order-service'],
            allowImplicitConfirm: false,
            multiplePriorityInsurances: false,
            insurancePriorities: []
        },
        reserveEngines: {
            siteUrl: ''
        },
        companyInfo: {
            loyaltyProgramName: 'Websky Club',
            iataCode: 'ZZ',
            ticketNumberCode: '00Z',
            exarePrivacyPolicyURL: 'https://google.com',
            exareRulesURL: 'https://google.com',
            subsidyFaresConditionURL: 'https://websky.aero/',
            transferM2ConditionURL: null,
            loyaltyProgramRegistrationUrl: '',
            loyaltyProgramAccountUrl: null,
            farelockURL: '',
            refundOptionURL: '',
            loyalty: {
                links: [
                    {
                        title: 'Statuses',
                        url: 'https://websky.tech'
                    },
                    {
                        title: 'Earn',
                        url: 'https://websky.tech'
                    },
                    {
                        title: 'Use',
                        url: 'https://websky.tech'
                    },
                    {
                        title: 'FAQ',
                        url: 'https://websky.tech'
                    }
                ]
            },
            multiInsurance: true,
            specialDocumentForInsurance: true
        },
        servicesAvailable: {
            animal: false
        },
        stepsAvailable: {
            [StepsEnum.Meal]: true
        },
        FFPRegex: /^\d{6}$/,
        roundMoneyAmount: false,
        purchasePredictionThreshold: 0.6,
        telegramLoginBotId: null,
        socialAuthCallbackUrl: null,
        showLeavePageModal: false,
        showCitiesPlaceholder: false,
        isOldConfirmOption: false,
        splitCartFlightPassengers: false,
        fareGroupVariant: 'small',
        showBookingPreview: true,
        collectMetrics: true,
        useYandexMetrika: true,
        useSberAds: true,
        showFareGroupUpgradeOptions: true,
        usePixel: false,
        showTaxesInfo: false,
        alternativeRouting: false
    },
    validate: function () {
        var _a;
        return ((_a = ConfigSchema.safeParse(this).error) === null || _a === void 0 ? void 0 : _a.errors) || [];
    }
};
const mergeAuthMethods = (defaultConfig, overrideConfig) => {
    var _a, _b, _c, _d;
    return (Object.assign(Object.assign({}, defaultConfig.global.authMethods), { blockedRegistrationEmailDomains: (_c = (_b = (_a = overrideConfig === null || overrideConfig === void 0 ? void 0 : overrideConfig.global) === null || _a === void 0 ? void 0 : _a.authMethods) === null || _b === void 0 ? void 0 : _b.blockedRegistrationEmailDomains) !== null && _c !== void 0 ? _c : (_d = defaultConfig.global.authMethods) === null || _d === void 0 ? void 0 : _d.blockedRegistrationEmailDomains }));
};
export const mergeConfig = (defaultConfig, initConfig) => {
    var _a, _b, _c, _d;
    const mergedConfig = merge({}, defaultConfig, initConfig);
    if ((_a = mergedConfig.SearchForm) === null || _a === void 0 ? void 0 : _a.selectableCurrencies) {
        mergedConfig.SearchForm.selectableCurrencies =
            (_c = (_b = initConfig === null || initConfig === void 0 ? void 0 : initConfig.SearchForm) === null || _b === void 0 ? void 0 : _b.selectableCurrencies) !== null && _c !== void 0 ? _c : (_d = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.SearchForm) === null || _d === void 0 ? void 0 : _d.selectableCurrencies;
    }
    mergedConfig.global.authMethods = mergeAuthMethods(mergedConfig, initConfig);
    return mergedConfig;
};
export const applyConfig = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if ((_a = config === null || config === void 0 ? void 0 : config.global) === null || _a === void 0 ? void 0 : _a.i18n) {
        extendI18n(config.global.i18n);
    }
    if ((_b = config === null || config === void 0 ? void 0 : config.global) === null || _b === void 0 ? void 0 : _b.apiUrl) {
        setApiUrl(config.global.apiUrl);
    }
    if ((_c = config === null || config === void 0 ? void 0 : config.global) === null || _c === void 0 ? void 0 : _c.socialAuthCallbackUrl) {
        config.global.socialAuthCallbackUrl = removeTrailingSlash(config.global.socialAuthCallbackUrl);
    }
    const mergedConfig = merge({}, defaultConfig, config);
    /**
     * WEBSKY-7938: collectMetrics является общим рубильником для всех метрик
     * Если collectMetrics = false, принудительно устанавливаем:
     */
    if (mergedConfig.global.collectMetrics === false) {
        mergedConfig.global.usePixel = false;
        mergedConfig.global.useYandexMetrika = false;
        mergedConfig.global.useSberAds = false;
    }
    mergedConfig.global.additionalResources.extraScripts = [
        ...new Set([
            ...(((_e = (_d = defaultConfig.global) === null || _d === void 0 ? void 0 : _d.additionalResources) === null || _e === void 0 ? void 0 : _e.extraScripts) || []),
            ...(((_g = (_f = config.global) === null || _f === void 0 ? void 0 : _f.additionalResources) === null || _g === void 0 ? void 0 : _g.extraScripts) || [])
        ])
    ];
    mergedConfig.global.additionalResources.extraSvgs = [
        ...new Set([
            ...(((_j = (_h = defaultConfig.global) === null || _h === void 0 ? void 0 : _h.additionalResources) === null || _j === void 0 ? void 0 : _j.extraSvgs) || []),
            ...(((_l = (_k = config.global) === null || _k === void 0 ? void 0 : _k.additionalResources) === null || _l === void 0 ? void 0 : _l.extraSvgs) || [])
        ])
    ];
    mergedConfig.Engine.defaultSteps = ((_m = config === null || config === void 0 ? void 0 : config.Engine) === null || _m === void 0 ? void 0 : _m.defaultSteps) || defaultConfig.Engine.defaultSteps;
    mergedConfig.global.authMethods = mergeAuthMethods(mergedConfig, config);
    if (mergedConfig.global.companyInfo.iataCode !== 'ZZ') {
        const validationErrors = mergedConfig.validate();
        if (validationErrors.length > 0) {
            const fields = validationErrors.map(error => error.path.join('.'));
            const message = `Invalid config, fields: ${fields.join(', ')}`;
            console.error(message, validationErrors);
            captureErrorSentry(message);
        }
    }
    window.__webskyEngineConfig = Object.freeze(Object.assign({}, mergedConfig));
    window['__webskyChangeLocale'] = (locale) => {
        changeLocale(locale).then(() => window.location.reload());
    };
    window['__webskyCoreVersion'] = process.env.PACKAGE_VERSION;
    return mergedConfig;
};
export const ConfigContext = React.createContext(defaultConfig);
export const useConfig = () => useContext(ConfigContext);
export const ModeContext = React.createContext(Mode.Booking);
export const useIsMode = (mode) => {
    return useContext(ModeContext) === mode;
};
export const useIsCheckout = () => {
    return useIsMode(Mode.Booking);
};
export const useIsCheckin = () => {
    return useIsMode(Mode.Checkin);
};
